import {
  IconBookmark,
  IconClose,
  IconFavorite,
  IconSearch,
} from "app/components/Icon/Icon";
import SegmentedControl from "app/components/SegmentedControl/SegmentedControl";
import SummaryLogic from "app/logic/summaryLogic";
import isPublicView from "app/utils/publicViewUtils";
import cx from "classnames";
import React, { lazy, Suspense, useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import "../../EventsScreenHeader.scss";
import "./HeaderLayoutMobile.scss";
const Bookmarks: React.LazyExoticComponent<any> = lazy(
  () => import("../../../../components/Bookmarks/Bookmarks")
);
const SearchModal: React.LazyExoticComponent<any> = lazy(
  () => import("../../components/Search/components/SearchModal/SearchModal")
);
const Filter: React.LazyExoticComponent<any> = lazy(
  () => import("../../components/Filter/Filter")
);
type Props = {
  className?: any;
  getTabs: (...args: Array<any>) => any;
  onClickBookmarks: (...args: Array<any>) => any;
  bookmarksActive: boolean;
  onClickFavourites: (...args: Array<any>) => any;
  bookmarksTotal: number;
  loadFavourites: (...args: Array<any>) => any;
  loadBookmarks: (...args: Array<any>) => any;
  onClickFutures: Function;
  numberOfFutureEvents: number;
  futures: boolean;
  disableFilterTab: boolean;
  isCompetitionListLoading: boolean;
  favouritesOnly: boolean;
  currentFavouritesCount: number;
  tabTypes: any;
};

const EventsScreenHeaderMobile: React.FC<Props> = props => {
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    SummaryLogic.updateSummary();
  }, []);

  const openModal = () => {
    window.scrollTo(0, 0);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const {
    getTabs,
    bookmarksActive,
    bookmarksTotal,
    disableFilterTab,
    tabTypes,
    isCompetitionListLoading,
    favouritesOnly,
    currentFavouritesCount,
    onClickBookmarks,
    onClickFutures,
    numberOfFutureEvents,
    futures,
  } = props;

  const showBookmarksButton = !favouritesOnly;
  const isBookmarksDisabled = favouritesOnly || isCompetitionListLoading;
  const isFavouritesDisabled = isCompetitionListLoading;
  const showNavigationFilter = !bookmarksActive && !favouritesOnly;

  return (
    <div className="events-screen-header__options">
      <div className="events-screen-header__options__item">
        <div
          className={cx("search-events-header__filter-by", {
            "search-events-header__filter-by--no-filter":
              bookmarksActive && favouritesOnly,
          })}
        >
          {showBookmarksButton && (
            <button
              id="Bookmark"
              onClick={onClickBookmarks}
              className={cx("events-screen-header__options__search-button", {
                "events-screen-header__options__search-button--bookmarks-active":
                  bookmarksActive,
                disabled: isBookmarksDisabled || isPublicView(),
              })}
              disabled={isBookmarksDisabled}
            >
              {bookmarksTotal > 0 && (
                <div className="badge">
                  <div>{bookmarksTotal}</div>
                </div>
              )}
              {bookmarksActive && (
                <div className="badge" data-qa="bookmarks-header__icon-close">
                  <IconClose />
                </div>
              )}
              <IconBookmark />
            </button>
          )}
          {bookmarksActive ? (
            <Suspense fallback={<div className="fallback">loading...</div>}>
              <Bookmarks />
            </Suspense>
          ) : (
            <React.Fragment>
              {favouritesOnly && (
                <div className="favourites-header">
                  <span data-qa="favourites-header__label__text">
                    <FormattedMessage id="events-favorites" />
                  </span>
                  <span data-qa="favourites-header__label__count">
                    &nbsp;({currentFavouritesCount})
                  </span>
                </div>
              )}
              <button
                id="Favorite"
                onClick={() => props.onClickFavourites()}
                className={cx("events-screen-header__options__search-button", {
                  "events-screen-header__options__search-button--favourites-active":
                    favouritesOnly,
                  disabled: isFavouritesDisabled || isPublicView(),
                })}
                disabled={isFavouritesDisabled}
              >
                <div
                  className={
                    currentFavouritesCount === 0 && !favouritesOnly
                      ? "hide badge"
                      : "badge"
                  }
                >
                  {favouritesOnly ? (
                    <span data-qa="favourites-header__icon-close">
                      <IconClose />
                    </span>
                  ) : (
                    <div>{currentFavouritesCount}</div>
                  )}
                </div>
                <IconFavorite />
              </button>
              {!favouritesOnly && (
                <Suspense fallback={<div className="fallback">loading...</div>}>
                  <Filter />
                </Suspense>
              )}
            </React.Fragment>
          )}
        </div>
        {showNavigationFilter && (
          <div className="search-events-and-leagues">
            <SegmentedControl
              tabs={getTabs()}
              disableFilterTab={disableFilterTab}
              tabTypes={tabTypes}
            />
            <div
              className={cx("search-events-and-leagues__futures-toggle", {
                "search-events-and-leagues__futures-toggle--active": futures,
                "search-events-and-leagues__futures-toggle--disabled":
                  numberOfFutureEvents === 0,
              })}
              onClick={() => {
                onClickFutures(!futures);
              }}
            >
              <FormattedMessage
                tagName="span"
                id="events-screen-header-futures"
              />
            </div>
            <button
              onClick={openModal}
              className="events-screen-header__options__search-button"
            >
              <IconSearch />
            </button>
            {modalOpen && (
              <Suspense fallback={<div className="fallback">loading...</div>}>
                <SearchModal closeModal={closeModal} />
              </Suspense>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  bookmarksTotal: state.bookmarkListModel.total,
  favouritesOnly: state.competitionListModel.favouritesOnly,
  isCompetitionListLoading: state.competitionListModel.isCompetitionListLoading,
  futures: state.competitionListModel.futures,
});

const mapDispatchToProps = (dispatch: any) => ({
  loadBookmarks: () => {
    dispatch.bookmarkListModel.setBookmarkList();
  },
  loadFavourites: () => {
    dispatch.favouritesListModel.setFavouriteList();
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EventsScreenHeaderMobile);
